import axios from 'axios';

export class ImportService {
    http = null;
    baseUrl = 'http://localhost:5000/api';

    constructor() {
        this.http = axios.create({
            baseURL: this.baseUrl,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    // Extract data from localStorage
    extractLocalStorageData() {
        const ingredients = this.getLocalStorageData('ingredients');
        const products = this.getLocalStorageData('products');
        const recipes = this.getLocalStorageData('recipies');
        const commands = this.getLocalStorageData('commands');

        return {
            ingredients: ingredients.map(item => ({
                id: item.id,
                code: item.code || '',
                title: item.title || ''
            })),
            products: products.map(item => ({
                id: item.id,
                code: item.code || '',
                title: item.title || '',
                description: item.description || ''
            })),
            recipes: recipes.map(item => ({
                id: item.id,
                title: item.title || '',
                description: item.description || '',
                qty: item.qty || 0,
                ingredients: (item.ingredients || []).map(ing => ({
                    ingredientId: ing?.id,
                    quantity: ing?.qty || 0
                }))
            })),
            commands: commands.map(item => ({
                id: item.id,
                title: item.title || '',
                description: item.description || '',
                recipeId: item.recipyId || item.recipeId || '',
                qty: item.qty || 0,
                status: item.status || 'Αναμονή'
            }))
        };
    }

    getLocalStorageData(key) {
        try {
            const data = localStorage.getItem(key);
            return data ? JSON.parse(data) : [];
        } catch (error) {
            console.error(`Error parsing localStorage data for key '${key}':`, error);
            return [];
        }
    }

    // Import data to backend
    async importData(importData) {
        try {
            const response = await this.http.post('/import/data', importData);
            return response.data;
        } catch (error) {
            console.error('Error importing data:', error);
            throw error;
        }
    }

    // Clear localStorage data after successful import
    clearLocalStorageData() {
        const keys = ['ingredients', 'products', 'recipies', 'commands'];
        keys.forEach(key => {
            localStorage.removeItem(key);
        });
    }
}
